import { render, staticRenderFns } from "./CcConfirmModal.ts.vue?vue&type=template&id=63ed9964"
import script from "./CcConfirmModal.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./CcConfirmModal.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CcConfirmModal.ts.vue?vue&type=style&index=0&id=63ed9964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports